var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero-section'),_c('v-container',[_c('div',{staticClass:"display-2 text-center font-weight-bold my-6"},[_vm._v(" Our Services ")]),_c('services-section')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }